import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Alert, Spinner } from 'react-bootstrap'
import axiosInstance from '../services/axiosInterceptor'
import OfficialDocLayout from './print/OfficialDocLayout'
import { fmtDateTHFull } from './aoShared'

// พิมพ์บันทึกข้อความ (แบบราชการ)
export default function MemoPrint() {
  const { mmId } = useParams()
  const [memo, setMemo] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    axiosInstance.get(`/api/ao/memos/${mmId}`)
      .then(res => { if (res.data.success) setMemo(res.data.data) })
      .catch(err => setError(err.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ'))
  }, [mmId])

  if (error) return <div className="p-4"><Alert variant="danger">{error}</Alert></div>
  if (!memo) return <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>

  return (
    <OfficialDocLayout title="บันทึกข้อความ" backLink="/my/memos" showCrest>
      <table style={{ width: '100%', marginTop: 8 }}>
        <tbody>
          <tr>
            <td style={{ width: '55%' }}>ที่ {memo.mm_full_no || '..............'}</td>
            <td>วันที่ {fmtDateTHFull(memo.mm_proposed_at || memo.created_at)}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ marginTop: 6 }}>เรื่อง&nbsp;&nbsp;{memo.mm_subject}</div>
      <div>เรียน&nbsp;&nbsp;ผู้อำนวยการโรงเรียน</div>

      {memo.mm_body ? (
        <div style={{ marginTop: 12 }} dangerouslySetInnerHTML={{ __html: memo.mm_body }} />
      ) : (
        <div className="text-muted" style={{ marginTop: 12 }}>— ไม่มีเนื้อหา —</div>
      )}

      <div className="doc-sign" style={{ marginLeft: '45%' }}>
        <div>ลงชื่อ ................................................</div>
        <div style={{ marginTop: 6 }}>({memo.created_by_name})</div>
        <div>ผู้เสนอ</div>
      </div>

      <div style={{ marginTop: 28, border: '1px solid #000', padding: '10px 14px', minHeight: '3.2cm' }}>
        <div style={{ fontWeight: 'bold' }}>ความเห็น / คำสั่งการของผู้บริหาร</div>
        <div style={{ minHeight: 40, whiteSpace: 'pre-wrap' }}>{memo.mm_exec_comment || ''}</div>
        <div className="doc-sign" style={{ marginLeft: '45%', marginTop: 12 }}>
          <div>ลงชื่อ ................................................</div>
          <div style={{ marginTop: 6 }}>({memo.exec_by_name || '....................................'})</div>
          <div>ผู้อำนวยการโรงเรียน</div>
        </div>
      </div>
    </OfficialDocLayout>
  )
}
